<template>
  <div :class="`m-mobile m-mobile-${routeType}-main micnp`">
    <div class="micnp-tab">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="南平简介" name="first">
          <div class="micnanpin-info">
            <bs-detail
              :filter="{}"
              :meta="{ module:'sys-area', field:'info' }"
              :is-init="true"
              :is-loading="false"
            >
              <template slot="data" slot-scope="slot">
                <div class="micnanpin-info-item micnanpin-info-itemselect">
                  <p v-html="slot.data.remark"></p>
                </div>
              </template>
            </bs-detail>
          </div>
        </el-tab-pane>
        <el-tab-pane label="朱子简介" name="second">
          <bs-detail
            :filter="{}"
            :meta="{ module:'single-article', field:'zzznp' }"
            :is-loading="false"
            :is-init="true"
          >
            <template slot="data" slot-scope="slot">
              <!-- <h3 class="micnp-znptitle" v-text="slot.data.artName"></h3> -->
              <div class="micnp-znpimg" v-if="slot.data.imgUrl">
                <img :src="slot.data.imgUrl" />
              </div>
              <div class="micnp-znpcontent">
                <div class="micnp-znpcontentinfo">
                  <!-- <span class="micnp-znpccontent-info-left" v-text="slot.data.createDate"></span>
                  <span class="micnp-znpccontent-info-mid" v-text="slot.data.createUserId"></span>-->
                  <!-- <span class="micnp-znpccontent-info-right">
                    <img src="../../assets/mobile/yidu@2x.png">
                    {{slot.data.click}}已读
                  </span>-->
                </div>
                <div class="micnp-znpccontenttxt" style="text-indent: 2em;" v-html="slot.data.artContent"></div>
              </div>
            </template>
          </bs-detail>
        </el-tab-pane>
        <el-tab-pane label="朱子生平" name="third">
           <div style="position:relative">
                  <img src="../../assets/mobile/sp.png" alt="" v-show="!isShow" style="width: 100%;">
                  <a href="javascript:;" class="zzsp-detail" @click="handleShow">详情</a>
              </div>
               <div class="timeaxis" v-show="isShow">
                 <div style="text-align: center;">
                  <img style="width: 3.3rem;" src="../../assets/portal/fanhui.png"  @click="handleShow">
                 </div>
                <bs-list
                  :filter="{}"
                  :meta="{ module:'life-resume', field:'info' }"
                  :is-loading="false"
                  :is-init="true">
                  <template slot="data" slot-scope="slot">
                    <el-steps direction="vertical">
                      <el-step
                        :title="item.dynasty+' '+item.year+'年'+' '+item.age+'岁'"
                        :description="item.remark"
                        v-for="item in slot.data"
                        :key="item.resumeId"
                      ></el-step>
                    </el-steps>
                  </template>
                  <template slot="empty">空数据</template>
                </bs-list>
              </div>
        </el-tab-pane>
        <el-tab-pane label="历朝褒封" name="four">
          <content class="life3-content">
            <p style="text-indent:2em;text-align:left">乾隆四十三年奉敕修纂的《钦定国子监志》中，列“先贤朱子”条目：</p>
            <p
              style="text-indent:2em;text-align:left"
            >宋淳祐元年从祀；元至正二十二年封齐国公；明崇祯十五年称为先贤，位在七十子之下，汉唐诸儒之上；国朝康熙五十一年升为十一哲。</p>
            <p
              style="text-indent:2em;text-align:left"
            >孔庙尊奉的是大成至圣的孔子。孔子塑像的东西侧是“四配”，“四配”是从祀的最高等级。接着是从祀第二等级的“十哲”。十哲之下，依次是“先贤”、“先儒”。</p>
            <p
              style="text-indent:2em;text-align:left"
            >四配是孔子的四大弟子，颜渊﹑子思居东，曾参﹑孟轲居西。十哲是孔子优秀的十位学生：次东西向的是闵损、冉雍、端木赐、仲由、卜商；次西东向的是冉耕、宰予、冉求、言偃、颛孙师。先贤是孔庙中从祀的第三个等级，大多数为孔子的弟子，周敦颐、二程等大儒也位列其中，共79人。先儒是孔庙中从祀的第四等级，为历代知名儒者，共77人，如杨时、李侗等。</p>
            <p
              style="text-indent:2em;text-align:left"
            >宋淳祐元年（1241），诏朱子从祀孔庙，入孔庙的先儒行列。明崇祯十五年（1642），诏称朱子为“先贤”，地位列于汉唐诸儒之上。清康熙五十一年（1712），朱子在孔庙从祀诸儒中的位置，从“先贤”提到“十哲”之次，位在卜商之后，次东西向。非孔门弟子而入“十哲”之次的，仅朱子一人，也由此，“十哲”变成“十一哲”。清乾隆三年（1738），升孔子弟子有若为十二哲，位在卜商之下，移朱子位于西面。至此，孔庙内“四配十二哲”的规制确立。</p>
            <p
              style="text-indent:2em;text-align:left"
            >统治者对朱子进行褒封的同时，朱子的理论学说也上升至官方意识形态的层面，据《元史·选举志》《明史·选举志》《清史稿·选举志》记载，朱子的《四书集注》、《周易本义》《诗集传》为元、明、清三代科举考试的必读教材和出题蓝本，三个朝代的《选举志》在“《四书》主朱子《集注》，《易》主程《传》、朱子《本义》……《诗》主朱子《集传》”这句话上，基本一致。科举必读的“四书五经”九部经典中，朱子占六部。</p>
            <p
              style="text-indent:2em;text-align:left"
            >清朱玉编的《朱子文集大全类编》&nbsp;第一册卷三专列《历朝褒典》一节；兰宗荣先生的《朱子的旅游世界——朱熹旅游文化与文化旅游研究》一书，也专列《历代皇帝对朱子的褒封与祀典》一节。现综合科举制度史等相关内容，将朱子历朝褒封情况整理如下：</p>
            <table
              style="border-collapse: collapse; border-color: #000000; margin-left: auto; margin-right: auto;"
              border="1"
            >
              <tbody>
                <tr>
                  <td width="10%">
                    <p>
                      <strong>朝代</strong>
                    </p>
                  </td>
                  <td width="15%">
                    <p>
                      <strong>年号</strong>
                    </p>
                  </td>
                  <td width="20%">
                    <p>
                      <strong>公元纪年</strong>
                    </p>
                  </td>
                  <td width="75%">
                    <p>
                      <strong>褒封情况</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td rowspan="14" width="34">
                    <p>
                      <strong>宋</strong>
                    </p>
                  </td>
                  <td width="54">
                    <p>宁宗嘉泰二年</p>
                  </td>
                  <td width="53">
                    <p>1202</p>
                  </td>
                  <td width="409">
                    <p>诏朱子华文阁待制与致仕恩泽。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>宁宗嘉定元年</p>
                  </td>
                  <td width="53">
                    <p>1208</p>
                  </td>
                  <td width="409">
                    <p>诏赐朱子遗表恩泽，赐谥曰“文”，世人尊称文公。与“元公”周敦颐、“纯公”程颢、“正公”程颐、“明公”张载、“宣公”张栻并列。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>嘉定三年</p>
                  </td>
                  <td width="53">
                    <p>1210</p>
                  </td>
                  <td width="409">
                    <p>追赠朱子为中散大夫，宝谟阁直学士，以明堂恩加通议大夫。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>嘉定五年</p>
                  </td>
                  <td width="53">
                    <p>1212</p>
                  </td>
                  <td width="409">
                    <p>宁宗听从国子司业刘爚的建议，以朱子所撰《四书集注》、《白鹿洞书院学规》颁于太学，作为教科书。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>理宗宝庆三年</p>
                  </td>
                  <td width="53">
                    <p>1227</p>
                  </td>
                  <td width="409">
                    <p>宋理宗认为《四书集注》“发挥圣贤之蕴，羽翼斯文，有补治道”，&nbsp;诏赠朱子太师，追封信国公。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>理宗绍定三年</p>
                  </td>
                  <td width="53">
                    <p>1230</p>
                  </td>
                  <td width="409">
                    <p>改封朱子徽国公。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>理宗嘉熙元年</p>
                  </td>
                  <td width="53">
                    <p>1237</p>
                  </td>
                  <td width="409">
                    <p>尤溪知县李修在朱子诞生地创建朱子祠，奉祀朱子父子。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>理宗嘉熙二年</p>
                  </td>
                  <td width="53">
                    <p>1238</p>
                  </td>
                  <td width="409">
                    <p>赐御书“建安书院”额。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>理宗淳祐元年</p>
                  </td>
                  <td width="53">
                    <p>1241</p>
                  </td>
                  <td width="409">
                    <p>诏恩从祀孔庙。加诏周敦颐、张载、程颐、程颢封爵，并祀孔庙。朱子取得与北宋四子并列的地位。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>理宗淳祐四年</p>
                  </td>
                  <td width="53">
                    <p>1244</p>
                  </td>
                  <td width="409">
                    <p>诏改沧州精舍为考亭书院，并赐御书额。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>理宗淳祐六年</p>
                  </td>
                  <td width="53">
                    <p>1246</p>
                  </td>
                  <td width="409">
                    <p>赐徽州“紫阳书院”御书额。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>理宗宝祐元年</p>
                  </td>
                  <td width="53">
                    <p>1253</p>
                  </td>
                  <td width="409">
                    <p>赐尤溪“南溪书院”御书额。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>度宗咸淳元年</p>
                  </td>
                  <td width="53">
                    <p>1265</p>
                  </td>
                  <td width="409">
                    <p>朝命宰执访朱子后人贤能者录用。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>度宗咸淳五年</p>
                  </td>
                  <td width="53">
                    <p>1269</p>
                  </td>
                  <td width="409">
                    <p>诏赐婺源朱氏故居名“文公阙里”。</p>
                  </td>
                </tr>
                <tr>
                  <td rowspan="4" width="34">
                    <p>
                      <strong>元</strong>
                    </p>
                  </td>
                  <td width="54">
                    <p>仁宗皇庆二年</p>
                  </td>
                  <td width="53">
                    <p>1313</p>
                  </td>
                  <td width="409">
                    <p>恢复科举，诏定以朱子《四书集注》为标准取士，朱学定为科场程式。《元史•选举志•科目》载：《大学》《论语》《孟子》《中庸》，用朱氏章句集注，《诗》以朱氏为主，《周易》以程氏、朱氏为主。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>惠帝至元元年</p>
                  </td>
                  <td width="53">
                    <p>1335</p>
                  </td>
                  <td width="409">
                    <p>奉旨婺源创徽国文公庙。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>惠帝至元二年</p>
                  </td>
                  <td width="53">
                    <p>1136</p>
                  </td>
                  <td width="409">
                    <p>朱子五世孙朱勋奉朝廷指派，携带次子朱域、三子朱境回祖居婺源掌管家庙祀事。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>惠宗至正二十二年</p>
                  </td>
                  <td width="53">
                    <p>1362</p>
                  </td>
                  <td width="409">
                    <p>追谥朱松“献靖公”，改封朱子齐国公。制词有云：“圣贤之藴，载诸经义。”</p>
                  </td>
                </tr>
                <tr>
                  <td rowspan="11" width="34">
                    <p>
                      <strong>明</strong>
                    </p>
                  </td>
                  <td width="54">
                    <p>洪武二年</p>
                  </td>
                  <td width="53">
                    <p>1369</p>
                  </td>
                  <td width="409">
                    <p>朱元璋下诏：&nbsp;国家明经取士，&nbsp;说经者以宋儒传著为主，&nbsp;行文者以典实纯正为主。追封朱子为徽国公。《明史•选举二》记载：《四书》主朱子集注，《易》主程《传》、朱子《本义》，&nbsp;《诗》主朱子《集传》。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>永乐十五年</p>
                  </td>
                  <td width="53">
                    <p>1417</p>
                  </td>
                  <td width="409">
                    <p>四月，颁《五经四书》《性理大全》于两京六部、国子监及天下府、州、县学。谕礼部曰：“此书，学者之根本。圣贤精蕴，悉具于是。其以朕意晓天下学者，令尽心讲明，无徒视为具文也。”朱子的思想成为学校根本和取士之制。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>景泰六年</p>
                  </td>
                  <td width="53">
                    <p>1455</p>
                  </td>
                  <td width="409">
                    <p>诏建安九世嫡长孙朱梴袭翰林院五经博士，婺源守祠九世孙朱楙送国子监读书。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>景泰七年</p>
                  </td>
                  <td width="53">
                    <p>1456</p>
                  </td>
                  <td width="409">
                    <p>旨令修祠堂春秋猪羊祭祀，钦降建安祠祭祝文。八世孙朱泗奏乞朱子门人黄榦、蔡沈、刘爚、真德秀配祀，从之。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>成化十八年</p>
                  </td>
                  <td width="53">
                    <p>1482</p>
                  </td>
                  <td width="409">
                    <p>题准歙县的紫阳书院有司致祭，“有司岁严祀事，而以蔡元定、黄勉斋配食”。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>弘治四年</p>
                  </td>
                  <td width="53">
                    <p>1491</p>
                  </td>
                  <td width="409">
                    <p>尤溪县国子监生林海奏准每年九月十五日文公诞辰于南溪书院特祭。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>弘治十五年</p>
                  </td>
                  <td width="53">
                    <p>1502</p>
                  </td>
                  <td width="409">
                    <p>题准婺源县修祠致祭。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>正德二年</p>
                  </td>
                  <td width="53">
                    <p>1507</p>
                  </td>
                  <td width="409">
                    <p>题准台州府建祠致祭。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>嘉靖二年</p>
                  </td>
                  <td width="53">
                    <p>1523</p>
                  </td>
                  <td width="409">
                    <p>诏命婺源朱子之十一世孙朱墅为翰林院五经博士，奉祀。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>嘉靖九年</p>
                  </td>
                  <td width="53">
                    <p>1530</p>
                  </td>
                  <td width="409">
                    <p>诏以献靖公（朱松）从祀启圣祠，会天下学宫一体并祀，通称先儒朱氏。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>崇祯十五年</p>
                  </td>
                  <td width="53">
                    <p>1642</p>
                  </td>
                  <td width="409">
                    <p>诏先儒朱子改称“先贤”，位在汉唐诸儒之上。</p>
                  </td>
                </tr>
                <tr>
                  <td rowspan="6" width="34">
                    <p>
                      <strong>清</strong>
                    </p>
                  </td>
                  <td width="54">
                    <p>康熙二十五年</p>
                  </td>
                  <td width="53">
                    <p>1686</p>
                  </td>
                  <td width="409">
                    <p>御书“学达性天”匾颁武夷精舍。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>康熙二十九年</p>
                  </td>
                  <td width="53">
                    <p>1690</p>
                  </td>
                  <td width="409">
                    <p>命先贤朱子十八世孙朱潆承袭五经博士以主持福建祭祀。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>康熙四十四年</p>
                  </td>
                  <td width="53">
                    <p>1705</p>
                  </td>
                  <td width="409">
                    <p>为建阳朱子祠题御匾并对联，御匾为“大儒世泽”，对联为“诚意正心阐邹鲁之实学，主敬穷理绍廉洛之真传”。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>康熙五十一年</p>
                  </td>
                  <td width="53">
                    <p>1712</p>
                  </td>
                  <td width="409">
                    <p>诏朱子从孔庙的配祀诸儒中，升至大成殿配享，位于十哲之次。御敕李光地等编《朱子全书》、《性理精义》，并御笔为序，在序中称朱子“集大成而绪千百年绝传之学，开愚蒙而立亿万世一定之规”。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>康熙五十五年</p>
                  </td>
                  <td width="53">
                    <p>1716</p>
                  </td>
                  <td width="409">
                    <p>御书“文山毓哲”额悬于尤溪南溪书院。</p>
                  </td>
                </tr>
                <tr>
                  <td width="54">
                    <p>乾隆三年</p>
                  </td>
                  <td width="53">
                    <p>1738</p>
                  </td>
                  <td width="409">
                    <p>升孔子弟子有若为十二哲，位在卜商之下，移朱子位于西面。</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </content>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
require("../../styles/mobile/mobile-cult-main.scss");
import ModuledataList from "../../views/mobile/mobile-cult-main-page";
import { scrypt } from "crypto";
export default {
  data() {
    return {
      isShow: false,
      routeType: "cult",
      activeName: "first"
    };
  },
  components: {
    MobileNavbar: () => import("../mobile/mobile-navbar"),
    mobileFooter: () => import("../mobile/mobile-footer"),
    BsList: () => import("../../components/bs-list"),
    BsDetail: () => import("../../components/bs-detail")
  },
  mounted() {},
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  methods: {
    handleShow(){
         this.isShow=!this.isShow
    },
    handleClick(tab, event) {}
  },
  created() {
    this.$menuFn.setTitle("微南平");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "mobile-cult-main") {
        this.$menuFn.setTitle("微南平");
      }
    }
  }
};
</script>
<style scoped>
@media screen and (min-width: 400px) {
   .micnp .zzsp-detail{
   text-decoration: none;
    color: #dd5c19;
    font-weight: bold;
    right: 10.6rem;
    bottom: 3.6rem;
    float: right;
    font-size: 1rem;
    position: absolute;
  }
}
@media screen and (max-width: 380px) {
   .micnp .zzsp-detail{
   text-decoration: none;
    color: #dd5c19;
    font-weight: bold;
    right: 9rem;
    bottom: 3.2rem;
    float: right;
    font-size: 1rem;
    position: absolute;
  }
}
@media screen and (max-width: 340px) {
   .micnp .zzsp-detail{
   text-decoration: none;
    color: #dd5c19;
    font-weight: bold;
    right: 7.6rem;
    bottom: 2.6rem;
    float: right;
    font-size: 1rem;
    position: absolute;
  }
}
</style>
 